import Vue from 'vue'
import VueRouter from 'vue-router';
import Router from 'vue-router';

Vue.use(Router)

// 引入index组件
import Index from "../pages/index.vue";
import lease from "../components/marketLease.vue";//市场物业租赁
import trade from "../components/marketTrade.vue";//市场交易量
import valume from "../components/marketValume.vue";//市场进出货量
import vehicle from "../components/marketVehicle.vue";//市场车辆进出量
import marketPrice from "../components/marketPrice.vue";//市场实时价格信息
import singleValume from "../components/marketSingleValume.vue";//市场单品进出货量
import tradeAmount from "../components/marketTradeAmount.vue";//市场交易金额
import map from "../components/marketMap.vue";//市场产地来源

// 配置路由地址
const routes = [{
  path: '/',
  component: Index
}, {
  path: '/index',
  component: Index
},{
  path: '/marketLease',
  component: lease
},{
  path: '/marketTrade',
  component: trade
},{
  path: '/marketValume',
  component: valume
},{
  path: '/marketVehicle',
  component: vehicle
},{
  path: '/marketPrice',
  component: marketPrice
},{
  path: '/marketSingleValume',
  component: singleValume
},{
  path: '/marketTradeAmount',
  component: tradeAmount
},{
  path: '/marketMap',
  component: map
},
]

const router = new VueRouter({
  routes
})
export default router
